import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface AgmConfig {
  mapApiKey: string;
  url: string;
}

export const agmConfig: AgmConfig = {
  ...environment.agmConf,
};

export const AGM_CONFIG = new InjectionToken<AgmConfig>('agmConfig');
